<div class="fuel-level d-flex flex-column gap-4" *ngIf="isPageInitialized">
  <div class="dashboard-top-section d-flex flex-row-reverse">
    <div class="search-menu-lists d-flex gap-2 search-height">
      <app-search [placeholder]="'fuelLevel.filters.searchAssets' | transloco" [searchTerm]="searchTerm"
        (searchTermUpdated)="onSearchTermUpdate($event)"></app-search>
      <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
    </div>
  </div>

  <div class="fuel-level-dashboard d-flex flex-xl-row gap-3 flex-column">
    <div class="fuel-level-left w-100">
      <app-fuel-levels></app-fuel-levels>
    </div>
    <div class="fuel-level-right d-flex flex-column gap-2">
      <app-low-fuel-level-alerts></app-low-fuel-level-alerts>
      <app-fuel-level-map class="h-100"></app-fuel-level-map>
    </div>
  </div>
</div>